<template>
  <a
    class="ads-item"
    :href="data[props.link]"
    target="_blank"
    @click.stop.prevent="adsClickHandler"
  >
    <el-image
      :src="data[props.img]"
      class="ads-item_inner"
      fit="cover"
      :alt="data.adtitle"
    ></el-image>

    <img class="ad-placeholder" :src="data[props.img]" :alt="data.adtitle" />

    <div
      v-if="showText"
      class="adv-title"
      :style="{ fontSize: fontSize, paddingBottom: offset }"
    >
      {{ data.adtitle }}
    </div>
  </a>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    props: {
      type: Object,
      default: () => ({
        img: "filesavepath",
        link: "linkurl",
        guid: "adguid",
      }),
    },
    fontSize: {
      type: String,
      default: "14px",
    },
    offset: {
      type: String,
      default: "0px",
    },
    showText: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    adsClickHandler() {
      var title = "首页-轮播图-" + this.data.adtitle;
      this.$store.dispatch("analysis/updateHits", { visitlocation: title });
      var href = this.data[this.props.link];
      this.$get(`${this.$store.state.api.webUrl}/admessage/clicklog.json`, {
        adguid: this.data[this.props.guid],
      });
      sessionStorage.setItem("title", "");
      if (href && href == "/caigou") {
        this.$emit("update");
      }
      if (href && href == "/publishNotice") {
        this.$get(
          `${this.$store.state.api.webUrl}/userobtain/isPushNotice`,
          {},
          (data) => {
            if (data == 1) {
              //可以正常发公告
              this.$get(
                `${this.$store.state.api.baseWebUrl}/dlms/login/getUrl`,
                {},
                (data) => {
                  window.open(data);
                }
              );
            }
            if (data == 2) {
              //需要领取免费机会
              this.$emit("power");
            }
            if (data == 3) {
              //免费领取的机会已到期
              this.$emit("tryon");
            }
          }
        );
      }
      if (href && href != "/caigou" && href != "/publishNotice") {
        window.open(href);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@css/var.scss";

.ads-item {
  display: block;
  width: 100%;
  height: 100%;
  background-color: $primaryColor1;

  .ads-item_inner {
    display: block;
    width: 100%;
    height: 100%;
  }

  .adv-title {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 0;
    text-align: center;
    color: white;
    line-height: 2em;
    background-color: rgba(0, 0, 0, 0.21);
  }
}

.ad-placeholder {
  display: block;
  width: 0;
  height: 0;
}
</style>
